import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"

const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const editVideoAction = createAsyncThunk(
    'edit-video',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.put(`/admins/api/edit-video`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const editVideoSlice = createSlice({
    name: 'edit-video',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(editVideoAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(editVideoAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
               
            })
            builder.addCase(editVideoAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const editVideoReducer = editVideoSlice.reducer